import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <section className="blog-page-hero not-found">
      <div className="container">
        <h1 className="heading-display">Page not found.</h1>
        <p className="text-body">The page you requested does not exist or has moved.</p>
        <Link to="/" className="btn btn--primary">Return home</Link>
      </div>
    </section>
  );
}
